import { Getter } from 'vuex'
import { IState } from './state'

const exhibitionName: Getter<IState, IState> = state => state.exhibitionName
const loggedIn: Getter<IState, IState> = state => state.loggedIn
const imagePopup: Getter<IState, IState> = state => state.imagePopup
const routes: Getter<IState, IState> = state => state.routes
const showMenu: Getter<IState, IState> = state => state.showMenu
const menu: Getter<IState, IState> = state => state.menu
const texts: Getter<IState, IState> = state => state.texts
const pagesContent: Getter<IState, IState> = (state) =>
  state.pagesContent
const parentContent: Getter<IState, IState> = (state, getters) =>
  getters.pagesContent[0]
const pageContent: Getter<IState, IState> = state => (slug: string) =>
state.pagesContent.find((item: any) => item.path === slug)
const footer: Getter<IState, IState> = state => state.footer

export default {
  exhibitionName,
  loggedIn,
  imagePopup,
  routes,
  showMenu,
  menu,
  texts,
  pagesContent,
  parentContent,
  pageContent,
  footer,
}
